import { StyleProp, StyleSheet, ViewStyle } from 'react-native';

const styles = StyleSheet.create({
  'flex-row': {
    flexDirection: 'row',
  },
  'flex-row-reverse': {
    flexDirection: 'row-reverse',
  },
  'flex-column': {
    flexDirection: 'column',
  },
  'flex-column-reverse': {
    flexDirection: 'column-reverse',
  },

  'flex-nowrap': {
    flexWrap: 'nowrap',
  },
  'flex-wrap': {
    flexWrap: 'wrap',
  },
  'wrap-reverse': {
    flexWrap: 'wrap-reverse',
  },

  'justify-content-start': {
    justifyContent: 'flex-start',
  },
  'justify-content-end': {
    justifyContent: 'flex-end',
  },
  'justify-content-center': {
    justifyContent: 'center',
  },
  'justify-content-between': {
    justifyContent: 'space-between',
  },
  'justify-content-around': {
    justifyContent: 'space-around',
  },
  'justify-content-evenly': {
    justifyContent: 'space-evenly',
  },

  'align-content-start': {
    alignContent: 'flex-start',
  },
  'align-content-end': {
    alignContent: 'flex-end',
  },
  'align-content-center': {
    alignContent: 'center',
  },
  'align-content-between': {
    alignContent: 'space-between',
  },
  'align-content-around': {
    alignContent: 'space-around',
  },
  'align-content-stretch': {
    alignContent: 'stretch',
  },

  'align-items-start': {
    alignItems: 'flex-start',
  },
  'align-items-end': {
    alignItems: 'flex-end',
  },
  'align-items-center': {
    alignItems: 'center',
  },
  'align-items-baseline': {
    alignItems: 'baseline',
  },
  'align-items-stretch': {
    alignItems: 'stretch',
  },

  'align-self-start': {
    alignSelf: 'flex-start',
  },
  'align-self-end': {
    alignSelf: 'flex-end',
  },
  'align-self-center': {
    alignSelf: 'center',
  },
  'align-self-baseline': {
    alignSelf: 'baseline',
  },
  'align-self-stretch': {
    alignSelf: 'stretch',
  },

  'flex-grow-1': {
    flexGrow: 1,
  },

  'flex-shrink-1': {
    flexShrink: 1,
  },
  'flex-0.4': {
    flex: 0.4,
  },
  'flex-0.6': {
    flex: 0.6,
  },
  'flex-1': {
    flex: 1,
  },

  'flex-1.25': {
    flex: 1.25,
  },

  'flex-2': {
    flex: 2,
  },

  'flex-3': {
    flex: 3,
  },

  'flex-4': {
    flex: 4,
  },

  'flex-5': {
    flex: 5,
  },
});

type FlexProps = keyof typeof styles;

export const flex = (...props: FlexProps[]): StyleProp<ViewStyle> => {
  const response: StyleProp<ViewStyle>[] = [];

  props.forEach((prop) => {
    if (styles.hasOwnProperty(prop)) {
      response.push(styles[prop as keyof typeof styles]);
    }
  });

  return response;
};
